
export default [
    {
        path: '/my',
        name: 'My',
        component: () => import('../views/my/Index'),
        meta:{
            title:'个人中心',
        }
    },
]